import { NavLink, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const TABS = [
  { to: "/admin/dashboard", label: "Dashboard" },
  { to: "/admin/photos", label: "Photos" },
  { to: "/admin/gear", label: "Gear" },
  { to: "/admin/credits", label: "Credits" },
  { to: "/admin/analytics", label: "Analytics" },
  { to: "/admin/settings", label: "Settings" },
];

export const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  if (user === null)
    return (
      <div className="admin-shell grain" style={{ padding: 48 }}>
        <p className="mono">Loading…</p>
      </div>
    );
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="admin-shell grain" data-testid="admin-shell">
      <div className="admin-nav">
        <div className="wrap admin-nav-in">
          <NavLink to="/" className="label" style={{ marginRight: 16 }} data-testid="admin-view-site">
            ← Site
          </NavLink>
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) => `tab${isActive ? " active" : ""}`}
              style={{ borderRadius: 3, marginBottom: 0, height: 30 }}
              data-testid={`admin-tab-${t.label.toLowerCase()}`}
            >
              {t.label}
            </NavLink>
          ))}
          <button
            className="btn btn-sm btn-ghost"
            style={{ marginLeft: "auto" }}
            onClick={async () => {
              await logout();
              nav("/admin/login");
            }}
            data-testid="admin-logout"
          >
            Log Out
          </button>
        </div>
      </div>
      <div className="wrap" style={{ padding: "40px 24px 80px" }}>
        {children}
      </div>
    </div>
  );
};

export const AdminHead = ({ title, sub }) => (
  <div style={{ marginBottom: 32 }}>
    <h1 className="disp" style={{ fontSize: "clamp(32px,6vw,54px)" }}>
      {title}
    </h1>
    {sub && (
      <p className="mono" style={{ fontSize: 13, marginTop: 8 }}>
        {sub}
      </p>
    )}
  </div>
);
